import * as THREE from 'three';
import EventDispatcher from "../common/EventDispatcher";
import {
    Global
} from "../common/global";

export default class Sounds {
    /**
     * Initializes an AICar instance.
     * @param {THREE.Scene} scene - The scene where the car will be added.
     */
    constructor(scene, camera) {
        this.scene = scene;
        this.camera = camera;
    }
    init() {
        this.events = EventDispatcher.getObj();
        this.events.addEventListener("SOUND_EVENTS", this.onEvents.bind(this));


    }
    onEvents(data) {
        switch (data['message']['event_type']) {
            case "init_sounds":
                this.createSounds();
                break;
            case "play_sound":
                this.playSound(data['message']['data']);
                break;
            case "stop_sound":
                this.fadeOut(data['message']['data']);
                break;
        }
    }
    playSound(data) {
        this[`${data['sndKey']}TI`] && clearInterval(this[`${data['sndKey']}TI`]);

        if (!Global.soundEnabled) return false;
        if (!this[`${data['sndKey']}Snd`].getLoop() && Global.soundEnabled) {
            if (!this[`${data['sndKey']}Snd`].isPlaying || data['sndKey'] !== 'hit') {
                this[`${data['sndKey']}Snd`].stop();
                this[`${data['sndKey']}Snd`].setVolume(0.5)
                this[`${data['sndKey']}Snd`].play();
            }

        }
        if (!this[`${data['sndKey']}Snd`].isPlaying && this[`${data['sndKey']}Snd`].getLoop()) {
            this[`${data['sndKey']}Snd`].setVolume(0.5)
            this[`${data['sndKey']}Snd`].play();
        }

    }
    fadeOut(data) {

        this[`${data['sndKey']}TI`] = setInterval(function (data) {
            var volume = this[`${data['sndKey']}Snd`].getVolume();
            if (volume > 0) {
                volume -= 0.03; // Adjust this value for the fadeout speed
                this[`${data['sndKey']}Snd`].setVolume(volume);
            } else {
                this[`${data['sndKey']}Snd`].stop();
                clearInterval(this[`${data['sndKey']}TI`]);
            }
        }.bind(this, data), 10); // Adjust this value for smoother or faster fadeout
    }
    createSounds() {
        this.listener = new THREE.AudioListener();
        this.camera.add(this.listener);


        this.catchSnd = new THREE.Audio(this.listener);
        this.catchSnd.setBuffer(Global.assets['sounds']['catch']['asset']);
        this.catchSnd.setLoop(false); // Set whether the audio should loop
        this.catchSnd.setVolume(0.5); // Set the volume (0 to 1)

        this.crowdSnd = new THREE.Audio(this.listener);
        this.crowdSnd.setBuffer(Global.assets['sounds']['crowd']['asset']);
        this.crowdSnd.setLoop(true); // Set whether the audio should loop
        this.crowdSnd.setVolume(0.5); // Set the volume (0 to 1)

        this.goalSnd = new THREE.Audio(this.listener);
        this.goalSnd.setBuffer(Global.assets['sounds']['goal']['asset']);
        this.goalSnd.setLoop(false); // Set whether the audio should loop
        this.goalSnd.setVolume(0.5); // Set the volume (0 to 1)

        this.kickSnd = new THREE.Audio(this.listener);
        this.kickSnd.setBuffer(Global.assets['sounds']['kick']['asset']);
        this.kickSnd.setLoop(false); // Set whether the audio should loop
        this.kickSnd.setVolume(0.5); // Set the volume (0 to 1)

        this.missSnd = new THREE.Audio(this.listener);
        this.missSnd.setBuffer(Global.assets['sounds']['miss']['asset']);
        this.missSnd.setLoop(false); // Set whether the audio should loop
        this.missSnd.setVolume(0.5); // Set the volume (0 to 1)

        this.musicSnd = new THREE.Audio(this.listener);
        this.musicSnd.setBuffer(Global.assets['sounds']['music']['asset']);
        this.musicSnd.setLoop(true); // Set whether the audio should loop
        this.musicSnd.setVolume(0.5); // Set the volume (0 to 1)




    }
}